var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import LogRocket from 'logrocket';
import { createContext, useCallback } from 'react';
import useAuthentication from '../hooks/useAuthentication';
import { getEnvironment, getEnvVariable } from '../utils/envUtils';
export var TealiumContext = /*#__PURE__*/createContext({
  trackView: function () {},
  trackEvent: function () {}
});
var TealiumProvider = function (_a) {
  var children = _a.children;
  var user = useAuthentication().user;
  var trackView = useCallback(function (pageViewParams) {
    var _a;
    //@ts-ignore
    window.utag_data = {
      page_l1: pageViewParams.page_l1 || 'MLP',
      page_l2: pageViewParams.page_l2 || 'Dental Provider',
      page_l3: pageViewParams.page_l3,
      page_l4: pageViewParams.page_l4,
      page_name: pageViewParams.page_name || "".concat(pageViewParams.page_l2 || 'Dental Provider', " - ").concat(pageViewParams.page_l4),
      user_id: pageViewParams.user_id || (user === null || user === void 0 ? void 0 : user.webGUID),
      user_role: pageViewParams.user_role || (user === null || user === void 0 ? void 0 : user.role),
      user_audience: 'Dental Providers',
      page_env: getEnvironment()
    };
    // @ts-ignore
    if (!!window.utag) {
      // @ts-ignore
      window.utag.view(window.utag_data);
      //@ts-ignore
      var tealiumSessionId = (_a = window.utag_data) === null || _a === void 0 ? void 0 : _a.tealium_session_id;
      if (!!tealiumSessionId && !!getEnvVariable('LOGROCKET_APP_ID')) {
        LogRocket.track("Tealium Session ID: ".concat(tealiumSessionId));
      }
    }
  }, [user]);
  var trackEvent = useCallback(function (clickParams) {
    // @ts-ignore
    if (!!window.utag) {
      // @ts-ignore
      window.utag.link({
        event_action: clickParams.event_action,
        event_name: clickParams.event_name,
        event_type: clickParams.event_type,
        event_status: clickParams.event_status,
        event_version: clickParams.event_version,
        event_results: clickParams.event_results,
        event_search_terms: clickParams.event_search_terms,
        user_id: clickParams.user_id
      });
    }
  }, []);
  return _jsx(TealiumContext.Provider, __assign({
    value: {
      trackView: trackView,
      trackEvent: trackEvent
    }
  }, {
    children: children
  }));
};
export default TealiumProvider;